var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8332 11.6667V9.33333C19.8332 6.11167 17.2215 3.5 13.9998 3.5C10.7782 3.5 8.1665 6.11167 8.1665 9.33333V11.6667M13.9998 16.9167V19.25M10.2665 24.5H17.7332C19.6934 24.5 20.6734 24.5 21.4221 24.1185C22.0807 23.783 22.6161 23.2475 22.9517 22.589C23.3332 21.8403 23.3332 20.8602 23.3332 18.9V17.2667C23.3332 15.3065 23.3332 14.3264 22.9517 13.5777C22.6161 12.9191 22.0807 12.3837 21.4221 12.0481C20.6734 11.6667 19.6934 11.6667 17.7332 11.6667H10.2665C8.30632 11.6667 7.32623 11.6667 6.57754 12.0481C5.91897 12.3837 5.38354 12.9191 5.04798 13.5777C4.6665 14.3264 4.6665 15.3065 4.6665 17.2667V18.9C4.6665 20.8602 4.6665 21.8403 5.04798 22.589C5.38354 23.2475 5.91897 23.783 6.57754 24.1185C7.32623 24.5 8.30632 24.5 10.2665 24.5Z",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock01);
export default __webpack_public_path__ + "static/media/lock-01.775d1494330a49550286a4fc0826a0a9.svg";
export { ForwardRef as ReactComponent };